export const SOUNDS_LIST: Record<string, readonly string[]> = <const>{
  'success-notify': ['notify-success.mp3'],
  'error-notify': ['notify-error.mp3'],
  'new-notification': ['notify-bell.mp3'],
  'crash-bet-made': ['bet-made.mp3'],
  'crash-round-started': ['round-start.mp3'],
  'crash-bet-won': ['bet-won.mp3'],
  'crash-bet-lost': ['bet-lost.mp3'],
  'jackpot-round-started': ['round-start.mp3'],
  'jackpot-bet-made': ['bet-made.mp3'],
  'jackpot-winner': ['jackpot-winner.mp3'],
  'jackpot-winner-big': ['jackpot-winner-big.mp3'],
  'jackpot-spinner-started': ['spinner-start.mp3'],
  'jackpot-spinner-click': ['spinner-click.mp3'],
  'wheel-bet-made': ['bet-made.mp3'],
  'wheel-spinner-click': ['wheel-click.mp3'],
  'piggy-bank-drop': ['piggy-bank-drop.mp3'],
  'piggy-bank-explosion': ['piggy-bank-explosion.mp3'],
  'defuse-slider-click': ['defuse-slider-click.mp3'],
  'defuse-won': ['defuse-won.mp3'],
  'defuse-lost': ['defuse-lost.mp3'],
  'defuse-cutter': ['defuse-cutter.mp3'],
  'defuse-console': ['defuse-console.mp3'],
  'mines-cell-click': ['mines-cell-click.mp3'],
  'mines-explosion': ['mines-explosion.mp3'],
  'mines-success': ['mines-success.mp3'],
  'mines-win': ['mines-win.mp3'],
  'battle-complete-craft': ['battle-complete-craft.mp3'],
  'battle-part-item': ['battle-part-item.mp3'],
  'cards-flip': ['cards-flip.mp3'],
  'cards-flip-2': ['cards-flip-2.mp3'],
  'cards-hover': ['cards-hover.mp3'],
  'cards-common-drop': ['cards-common-drop.mp3'],
  'cards-best-drop': ['cards-best-drop.mp3'],
  'cards-stacking': ['cards-stacking.mp3'],
  'cards-stacked': ['cards-stacked.mp3'],
  'battleship-chat-message': ['battleship-chat-message.mp3'],
  'battleship-miss': ['battleship-miss.mp3'],
  'battleship-hit': ['battleship-hit.mp3'],
  'battleship-sunk': ['battleship-sunk.mp3'],
  'battleship-no-time': ['battleship-no-time.mp3'],
  'battleship-lost': ['battleship-lost.mp3'],
  'battleship-won': ['battleship-won.mp3'],
  'battleship-join': ['battleship-join.mp3'],
  'super-wheel-won-bets': ['super-wheel-won-bets.mp3'],
  'super-wheel-coin-character': ['super-wheel-coin-character.mp3'],
  'super-wheel-coin-took-out': ['super-wheel-coin-took-out.mp3'],
  'super-wheel-coin-removed': ['super-wheel-coin-removed.mp3'],
  'super-wheel-coin-game': ['super-wheel-coin-game.mp3'],
  'super-wheel-coin-timer': ['super-wheel-coin-timer.mp3'],
  'super-wheel-miner-character': ['super-wheel-miner-character.mp3'],
  'super-wheel-miner-took-out': ['super-wheel-miner-took-out.mp3'],
  'super-wheel-miner-removed': ['super-wheel-miner-remove.mp3'],
  'super-wheel-miner-open': ['super-wheel-miner-open.mp3'],
  'super-wheel-miner-hover': ['super-wheel-miner-hover.mp3'],
  'super-wheel-miner-click': ['super-wheel-miner-click.mp3'],
  'super-wheel-miner-timer': ['super-wheel-miner-timer.mp3'],
  'super-wheel-drum-kick': ['super-wheel-drum-kick.mp3'],
  'super-wheel-dice-character': ['super-wheel-dice-character.mp3'],
  'super-wheel-dice-took-out': ['super-wheel-dice-took-out.mp3'],
  'super-wheel-dice-removed': ['super-wheel-dice-removed.mp3'],
  'super-wheel-dice-game': ['super-wheel-dice-game.mp3'],
  'super-wheel-dice-tick1': ['super-wheel-dice-tick1.mp3'],
  'super-wheel-dice-tick2': ['super-wheel-dice-tick2.mp3'],
  'super-wheel-dice-tick3': ['super-wheel-dice-tick3.mp3'],
  'super-wheel-dice-tick4': ['super-wheel-dice-tick4.mp3'],
  'super-wheel-dice-tick5': ['super-wheel-dice-tick5.mp3'],
  'super-wheel-case-open': ['super-wheel-case-open.mp3'],
  'super-wheel-case-removed-key': ['super-wheel-case-removed-key.mp3'],
  'super-wheel-case-start-line': ['super-wheel-case-start-line.mp3'],
  'super-wheel-case-stop-line': ['super-wheel-case-stop-line.mp3'],
  'super-wheel-case-character': ['super-wheel-case-character.mp3'],
  'super-wheel-case-took-out': ['super-wheel-case-took-out.mp3'],
  'super-wheel-case-removed': ['super-wheel-case-removed.mp3']
};
